export class NeptuneSnapshotProperties {
    'recoveryPointArn';
    'backupVaultName';
    'region';
    'sourceAccountId';
    'dbClusterIdentifier';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "recoveryPointArn",
            "baseName": "recoveryPointArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "backupVaultName",
            "baseName": "backupVaultName",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceAccountId",
            "baseName": "sourceAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "dbClusterIdentifier",
            "baseName": "dbClusterIdentifier",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NeptuneSnapshotProperties.attributeTypeMap;
    }
    constructor() {
    }
}
